// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"chart_cardContent__34yy4"};